import LoadingDots from 'components/LoadingDots';
import type Shipment from 'interfaces/PmParcel';
import { Campaign } from 'models/Campaign.model';
import { StateUpdater } from 'preact/hooks';
import { CampaignComponent } from '../CampaignComponent';
import {
  CampaignsContainer,
  CenterCampaign,
  LeftCampaign,
  RightCampaign,
} from './Campaigns.styles';
import { useCampaigns } from './useCampaigns';

interface CampaignsProps {
  shipment: Shipment;
  setIsCampaignsEmpty?: StateUpdater<boolean>;
}

export const Campaigns = ({
  shipment,
  setIsCampaignsEmpty,
}: CampaignsProps) => {
  const {
    campaignsContainerRef,
    isLoading,
    data: { promotionLayout, campaigns },
    onClickCampaign,
  } = useCampaigns({ shipment });

  const renderContent = () => {
    if (isLoading) {
      return <LoadingDots />;
    }

    if (!isLoading && (!campaigns || campaigns?.length === 0)) {
      setIsCampaignsEmpty(true);
      return null;
    }

    const leftCampaign = campaigns.find(
      (campaign: Campaign) => campaign.placement === 'left',
    );

    const centerCampaign = campaigns.find(
      (campaign: Campaign) => campaign.placement === 'center',
    );

    const rightCampaign = campaigns.find(
      (campaign: Campaign) => campaign.placement === 'right',
    );

    if (promotionLayout === 'large') {
      return (
        <CenterCampaign data-testid="center-campaign" layout={promotionLayout}>
          <CampaignComponent
            onClickCampaign={onClickCampaign}
            data={campaigns[0]}
          />
        </CenterCampaign>
      );
    }

    return (
      <>
        {leftCampaign && (
          <LeftCampaign data-testid="left-campaign" layout={promotionLayout}>
            <CampaignComponent
              onClickCampaign={onClickCampaign}
              data={leftCampaign}
            />
          </LeftCampaign>
        )}

        {centerCampaign && (
          <CenterCampaign
            data-testid="center-campaign"
            layout={promotionLayout}
          >
            <CampaignComponent
              onClickCampaign={onClickCampaign}
              data={centerCampaign}
            />
          </CenterCampaign>
        )}

        {rightCampaign && (
          <RightCampaign data-testid="right-campaign" layout={promotionLayout}>
            <CampaignComponent
              onClickCampaign={onClickCampaign}
              data={rightCampaign}
            />
          </RightCampaign>
        )}
      </>
    );
  };

  return (
    <CampaignsContainer ref={campaignsContainerRef}>
      {renderContent()}
    </CampaignsContainer>
  );
};
